export default "/images/75138efd6edde11ecf97dde6aa68ffd8.jpg";